import clsx from 'clsx';
import { Radio as MuiRadio, RadioProps } from '@material-ui/core';
import React, { InputHTMLAttributes } from 'react';
import { ReactComponent as RadioIconCheck } from 'common-assets/assets/icons/radioIcon-check.svg';

import useStyles from './Radio.style';

interface CustomRadioInputProps extends InputHTMLAttributes<HTMLInputElement> {
  testId?: string;
}
export interface CustomRadioProps {
  hideIcon?: boolean;
  inputProps?: CustomRadioInputProps;
  disabled?: boolean;
  className?: string;
  hasError?: boolean;
}

export const Radio: React.FC<RadioProps & CustomRadioProps> = ({
  hideIcon,
  inputProps,
  disabled,
  className,
  hasError,
  ...props
}) => {
  const c = useStyles({});
  const { testId, ...restInputProps } = inputProps || {};
  return (
    <MuiRadio
      {...props}
      disabled={disabled}
      inputProps={{
        ...restInputProps,
        'data-testid': inputProps?.testId || 'Radio-input',
      } as InputHTMLAttributes<HTMLInputElement>}
      classes={{
        root: clsx(c.root, hasError && c.error, className),
      }}
      icon={hideIcon ? null : (<RadioIconCheck className={c.radioIcon}/>)}
      checkedIcon={hideIcon ? null : (<RadioIconCheck className={c.radioIconCheck}/>)}
    />
  );
};
